import React from 'react'

const PrimaryButton = ({
  children,
  onClick,
  className,
  type = 'button',
  loading,
}) => {
  return (
    <button
      className={`btn btn-sm h-10 min-h-0 rounded-xl bg-button text-white shadow-button border-none hover:brightness-125 gap-2 normal-case text-sm font-semibold px-4 ${className} ${
        loading && 'loading'
      }`}
      onClick={onClick}
      type={type}
    >
      {children}
    </button>
  )
}

export default PrimaryButton
